import _sfc_main from "./component-library101.mjs";
import "./component-library102.mjs";
import normalizeComponent from "./component-library82.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.LinkButton, { staticClass: "play-pause-button", attrs: { "type": "button", "tag": "button", "primary": "" }, on: { "click": _setup.handleClick } }, [_c("svg", { staticClass: "play-pause-button__svg", attrs: { "xmlns": "http://www.w3.org/2000/svg", "viewBox": "0 0 30 30" } }, [!_vm.value ? [_c("path", { staticClass: "play-pause-button__path-foreground", attrs: { "d": "M6 1.3v27.4L29 15z" } })] : [_c("path", { staticClass: "play-pause-button__path-foreground", attrs: { "d": "M0 0h10v30H0zm20 0h10v30H20z" } })]], 2)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "6a72a3ba",
  null,
  null
);
const PlayPauseButton = __component__.exports;
export {
  PlayPauseButton as default
};
